import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 175-play
 * @see {GlyphIcon}
 */
const PlayIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M24.8175,16.86432,9.503,25.77667A1,1,0,0,1,8,24.91235V7.08765a1,1,0,0,1,1.503-.86432L24.8175,15.13568A1.00006,1.00006,0,0,1,24.8175,16.86432Z";
	}
}

export default PlayIcon;